export const benefitsGenerateAi = [
	{
		icon: '⏳',
		title: 'benefitsData_title1',
		subtitle: 'benefitsData_subtitle1',
	},
	{
		icon: '🥳',
		title: 'benefitsData_title2',
		subtitle: 'benefitsData_subtitle2',
	},
	{
		icon: '⭐️',
		title: 'benefitsData_title3',
		subtitle: 'benefitsData_subtitle3',
	},
	{
		icon: '🎑',
		title: 'benefitsData_title4',
		subtitle: 'benefitsData_subtitle4',
	},
	{
		icon: '🙌🏼',
		title: 'benefitsData_title5',
		subtitle: 'benefitsData_subtitle5',
	},
];
